import React from "react";
import styles from "./Expandable.module.css";
import cn from "../../lib/classnames";

type Props = {
    triggerChildren: React.ReactNode;
    expandingChildren: React.ReactNode;
    isExpanded: boolean;
};

export default function Expandable(props: Props) {
    return (
        <div
            className={cn(styles.container, props.isExpanded ? styles.expanded : styles.collapsed)}
        >
            {props.triggerChildren}
            <div className={styles.content}>{props.expandingChildren}</div>
        </div>
    );
}
